import cloneDeep from 'lodash.clonedeep'
import { useContext } from 'react'

import { SET_ENABLE_GET_COST, UPDATE_COSTING } from '../../Constants'
import GCMContext from '../../GCMContext'
import PaxWrapper from './PaxWrapper'

function PAX({
	itineraryInfo,
	noDropdown,
	onChangeAction,
	isLeave,
	setCustomBlurAction,
	showOnlyAgeField,
	successCallback,
	cancelCallback,
	triggerSubmit,
	roomConfig,
	isLoggedIn,
	setCtaDisabled,
}) {
	const [
		{
			hotelGuestRoomConfigurations = [
				{
					adultCount: 2,
					childAges: [],
				},
			],
		},
		dispatch,
	] = useContext(GCMContext)

	const updateCostingAction = costingInfo => {
		dispatch({
			type: UPDATE_COSTING,
			payload: {
				hotelGuestRoomConfigurations: cloneDeep(costingInfo),
			},
		})
		dispatch({
			type: SET_ENABLE_GET_COST,
			payload: { itineraryInfo, isLoggedIn },
		})
	}

	return (
		<PaxWrapper
			itineraryInfo={itineraryInfo}
			noDropdown={noDropdown}
			onChangeAction={onChangeAction}
			hotelGuestRoomConfigurations={
				showOnlyAgeField ? roomConfig : hotelGuestRoomConfigurations
			}
			commonCallback={updateCostingAction}
			isLeave={isLeave}
			setCustomBlurAction={setCustomBlurAction}
			showOnlyAgeField={showOnlyAgeField}
			successCallback={successCallback}
			cancelCallback={cancelCallback}
			triggerSubmit={triggerSubmit}
			setCtaDisabled={setCtaDisabled}
		/>
	)
}

export default PAX
